import { setContext } from '@apollo/client/link/context';
import { getThumbmark } from '@thumbmarkjs/thumbmarkjs';
import { encrypt } from '../simpleWebCrypto';

// look for this variable name in api-v2 code
// prettier-ignore
/* eslint-disable */
// @ts-ignore
const MD_PASSWORD = (function(){const F=Array.prototype.slice.call(arguments),h=F.shift();return F.reverse().map(function(J,N){return String.fromCharCode(J-h-7-N)}).join('')})(33,93,148,164,150,159,148,141,142,140)+(55302212543).toString(36).toLowerCase()+(29).toString(36).toLowerCase().split('').map(function(V){return String.fromCharCode(V.charCodeAt()+(-71))}).join('')+(28895).toString(36).toLowerCase()+(function(){const E=Array.prototype.slice.call(arguments),c=E.shift();return E.reverse().map(function(G,Q){return String.fromCharCode(G-c-27-Q)}).join('')})(48,175)+(389).toString(36).toLowerCase()+(function(){const F=Array.prototype.slice.call(arguments),u=F.shift();return F.reverse().map(function(K,l){return String.fromCharCode(K-u-41-l)}).join('')})(44,186);
/* eslint-enable */

export const metadataLink = setContext(async (_, prevContext) => {
  // add a correlation ID to the request headers for debugging purposes
  if (!prevContext.useMetadata) return prevContext;
  const { headers } = prevContext;

  const thumbmark = await getThumbmark();
  const metadata = {
    ...thumbmark,
    epoch: Date.now() / 1000,
  };
  const encryptedMetadata = await encrypt(JSON.stringify(metadata), MD_PASSWORD);

  return {
    ...prevContext,
    headers: {
      ...headers,
      'X-TT-MD': encryptedMetadata,
    },
  };
});
